import { create } from "zustand"
import { persist } from "zustand/middleware"

export interface PinnedPage {
  path: string
  label: string
  section?: string
}

interface PinnedPagesState {
  pinnedPages: PinnedPage[]
  addPin: (page: PinnedPage) => void
  removePin: (path: string) => void
  isPinned: (path: string) => boolean
  togglePin: (page: PinnedPage) => void
}

const MAX_PINNED_PAGES = 8

export const usePinnedPagesStore = create<PinnedPagesState>()(
  persist(
    (set, get) => ({
      pinnedPages: [],

      addPin: (page) =>
        set((state) => {
          if (state.pinnedPages.length >= MAX_PINNED_PAGES) {
            return state
          }
          if (state.pinnedPages.some((p) => p.path === page.path)) {
            return state
          }
          return { pinnedPages: [...state.pinnedPages, page] }
        }),

      removePin: (path) =>
        set((state) => ({
          pinnedPages: state.pinnedPages.filter((p) => p.path !== path),
        })),

      isPinned: (path) => get().pinnedPages.some((p) => p.path === path),

      togglePin: (page) => {
        const { isPinned, addPin, removePin } = get()
        if (isPinned(page.path)) {
          removePin(page.path)
        } else {
          addPin(page)
        }
      },
    }),
    {
      name: "manage2-pinned-pages",
    }
  )
)
